import type PlannedBreakForm from './forms/PlannedBreakForm'

const toBreaksPayload = (plannedBreakForms: PlannedBreakForm[]) => {
  return plannedBreakForms.map((form) => {
    return {
      startAt: form.get('start_at').value,
      endAt: form.get('end_at').value,
      duration: +form.get('duration').value,
      breakType: form.get('break_type').value,
      breakConfigurationId: form.get('break_configuration.id').value,
    }
  })
}

export { toBreaksPayload }
